<template>
  <div class="container">
    <!-- Modal -->
    <div class="modal fade modal-evidencia" id="listarEvidencias" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">

          <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h1 class="modal-title">Lista de evidências </h1>
              <!-- <small>Referênte ao item SLA <strong>{{consultaEvidencias.item_sla}}</strong> mês <strong>{{consultaEvidencias.mes}}</strong></small> -->
          </div>
          <div class="modal-body alert-body icon-acoes btable">
            <section class="loading" v-show="loadingEvidencias">
              <HalfCircleSpinner
                   :animation-duration="2000"
                   :size="60"
                   :color="'#3c8dbc'"
              />
            </section>
            <b-table v-show="!loadingEvidencias"
              striped hover
              :items="evidencias"
              v-if="evidencias.length"
              :fields="fieldsEvidencias"
              >

              <template v-slot:cell(arquivo)="data">
                  <a href="javascript:void(0)" v-on:click="downloadArquivo(data.value)" v-if="data.item.arquivo">Download</a>
                  <span v-else> - </span>
              </template>

              <template v-slot:cell(excluir)="data">
                <div class="btn-excluir">
                  <a href="javascript:void(0)" v-if="controlerLoadingDelete" v-on:click="excluirEvidencia(data.item.evidencia_id)"><i class="fa fa-times-circle-o"></i></a>
                  <a href="javascript:void(0)" v-else>Aguarde...</a>
                </div>
              </template>

              <template v-slot:cell(anulado)="data">

                  <div class="btn-anular" v-if="!data.value">
                    <a href="javascript:void(0)" v-if="controlerLoadingDelete" v-on:click="anularEvidencia(data.item.evidencia_id)" title="Anular evidência"><i class="fa fa-times-circle-o"></i></a>
                    <a href="javascript:void(0)" v-else>Aguarde...</a>
                  </div>
                  <div class="btn-desanular" v-else>
                    <a href="javascript:void(0)" v-if="controlerLoadingDelete" v-on:click="desanularEvidencia(data.item.evidencia_id)" title="Desanular evidência"><i class="fa fa-times-circle-o"></i></b-icon></a>
                    <a href="javascript:void(0)" v-else>Aguarde...</a>
                  </div>

              </template>

            </b-table>
              <div v-else-if="this.controlerLoading == false">
                <p class="sem-evidencias">Procurando evidências...</p>
              </div>
              <div v-else>
                <p class="sem-evidencias">Ops... não há evidências por aqui... (-:</p>
              </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {HalfCircleSpinner} from 'epic-spinners'

export default {
  props: ['consultaEvidencias'],
  data () {
    return {
      controlerLoadingDownload: true,
      controlerLoadingDelete: true,
      controlerLoading: null,
      env: process.env,
      zIndex: 999999,
      form: [],
      evidencias: [],
      fieldsEvidencias: [
        { key: 'mes_referencia', label: 'Mês Referência' },
        { key: 'nao_conformidade_apurada', label: 'Não Conformidade Apurada' },
        { key: 'numero_item', label: 'Item Sla' },
        // { key: 'unidade_metrica', label: 'Unidade Métrica' },
        { key: 'quantidade_apurada', label: 'Quantidade apurada' },
        { key: 'observacoes', label: 'Observações' },
        { key: 'arquivo', label: 'Arquivo' },
        { key: 'anulado', label: 'Anular' },
        { key: 'excluir', label: 'Excluir' }
      ],
      loadingEvidencias: true
    }
  },
  components: {
    HalfCircleSpinner
  },
  watch: {
    consultaEvidencias: function () {
      this.getEvidencias(this.consultaEvidencias)
    }
  },
  methods: {
    configuraEvidenciaAnulada: function () {
      let vm = this
      setTimeout(() => {
        let registrosAnulados = document.querySelectorAll('.btn-desanular')
        registrosAnulados.forEach(item => {
          let elem = item.parentElement.parentElement
          elem.style.textDecoration = 'line-through'
          elem.style.color = '#ccc'
        })
        vm.loadingEvidencias = false
      }, 0)
    },
    getEvidencias (evidencias) {
      let vm = this
      this.controlerLoading = false
      this.evidencias = []
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getevidenciaspormes`, evidencias, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.evidencias = response.data
        vm.controlerLoading = true
        vm.configuraEvidenciaAnulada()
      })
      .catch(function (error) {
        vm.controlerLoading = true
        vm.loadingEvidencias = false
        console.log(error)
      })
    },
    excluirEvidencia: function (id) {
      let vm = this
      if (!this.confirmarAcao()) {
        return
      }
      this.loadingEvidencias = true
      this.$axios.delete(`${this.env.FINANCEIRO.SLA}/evidencias/${id}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'application/json'
        },
        params: {
          'usuario_nome': this.$store.state.login.loginUsuario.usuario.name,
          'usuario_email': this.$store.state.login.loginUsuario.usuario.email
        }
      })
      .then(function (response) {
        let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
        vm.$store.commit('setRefreshComponente', refreshComponentes)
        vm.getEvidencias(vm.consultaEvidencias)
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    anularEvidencia: function (id) {
      let vm = this
      if (!this.confirmarAcao()) {
        return
      }
      this.loadingEvidencias = true
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/anularEvidencia`, {
        evidencia_id: id,
        'usuario_nome': this.$store.state.login.loginUsuario.usuario.name,
        'usuario_email': this.$store.state.login.loginUsuario.usuario.email
      },
        {
          headers: {
            'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
            'Content-Type': 'application/json'
          }
        })
      .then(function (response) {
        let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
        vm.$store.commit('setRefreshComponente', refreshComponentes)
        vm.getEvidencias(vm.consultaEvidencias)
      })
      .catch(function (error) {
        vm.loadingEvidencias = true
        console.log(error)
      })
    },
    desanularEvidencia: function (id) {
      let vm = this
      if (!this.confirmarAcao()) {
        return
      }
      this.loadingEvidencias = true
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/desanularEvidencia`, {
        evidencia_id: id,
        'usuario_nome': this.$store.state.login.loginUsuario.usuario.name,
        'usuario_email': this.$store.state.login.loginUsuario.usuario.email
      },
        {
          headers: {
            'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
            'Content-Type': 'application/json'
          }
        })
      .then(function (response) {
        let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
        vm.$store.commit('setRefreshComponente', refreshComponentes)
        vm.getEvidencias(vm.consultaEvidencias)
      })
      .catch(function (error) {
        vm.loadingEvidencias = true
        console.log(error)
      })
    },
    downloadArquivo: function (nomeArquivo) {
      let vm = this
      let dirBucket = 'evidencias'
      this.controlerLoadingDownload = false
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/downloadarquivo/${dirBucket}/${nomeArquivo}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.controlerLoadingDownload = true
        // Condição espefifica para acesso não autorizado retornado pela API predial-adm
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', {msg: response.data.mensagem, status: false, show: true})
          return
        }
        window.open(response.data.url, '_blank')
      })
    },
    confirmarAcao: function () {
      return confirm('Confirma esta ação?')
    }
  }
}
</script>
<style scoped src="../css/modalListarEvidencia.css"></style>




// WEBPACK FOOTER //
// ModalListarEvidencia.vue?4689fc06